module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/tabs-e6d89bc634fe912ea08647ce30d1da37.svg";